import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Products API
export const getProducts = async () => {
  const response = await apiClient.get('/products');
  return response.data;
};

export const getProduct = async (id) => {
  const response = await apiClient.get(`/products/${id}`);
  return response.data;
};

// Shop API
export const getShopInfo = async () => {
  const response = await apiClient.get('/shop');
  return response.data;
};

// Checkout API
export const createCheckout = async (data) => {
  const response = await apiClient.post('/checkout', data);
  return response.data;
};

export const getCheckoutStatus = async (id) => {
  const response = await apiClient.get(`/checkout/${id}`);
  return response.data;
};

// Feedbacks/Reviews API
export const getFeedbacks = async (params = {}) => {
  const response = await apiClient.get('/feedbacks', { params });
  return response.data;
};

// Cart management (client-side only, SellAuth uses checkout sessions)
export const getCart = () => {
  const cart = localStorage.getItem('riftone_cart');
  return cart ? JSON.parse(cart) : [];
};

export const addToCart = (product, variantId = null, quantity = 1) => {
  const cart = getCart();
  const existingItem = cart.find(
    item => item.productId === product.id && item.variantId === variantId
  );

  if (existingItem) {
    existingItem.quantity += quantity;
  } else {
    cart.push({
      productId: product.id,
      variantId: variantId,
      quantity: quantity,
      product: product,
    });
  }

  localStorage.setItem('riftone_cart', JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

export const removeFromCart = (productId, variantId = null) => {
  let cart = getCart();
  cart = cart.filter(
    item => !(item.productId === productId && item.variantId === variantId)
  );
  localStorage.setItem('riftone_cart', JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

export const updateCartQuantity = (productId, variantId = null, quantity) => {
  const cart = getCart();
  const item = cart.find(
    item => item.productId === productId && item.variantId === variantId
  );
  if (item) {
    item.quantity = quantity;
    localStorage.setItem('riftone_cart', JSON.stringify(cart));
    window.dispatchEvent(new Event('cartUpdated'));
  }
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem('riftone_cart');
  window.dispatchEvent(new Event('cartUpdated'));
};

export default apiClient;
